import { Breadcrumbs, Breadcrumb } from 'react-aria-components';
import styled, { css } from 'styled-components';
import { Link } from '@/components/Link';

const sharedFontStyles = css`
  font-size: var(--font-size-text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--grey-500);

  @media (width >= 48rem) {
    font-size: var(--font-size-text-sm);
  }
`;

const sharedLayout = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-small);
`;

export const Wrapper = styled.div`
  ${sharedLayout}
  padding: 0 var(--spacing-large) var(--spacing-base) 0;

  @media (width >= 48rem) {
    padding-inline: 0;
  }
`;

export const BackLink = styled(Link)`
  ${sharedFontStyles}
  text-decoration: none;
`;

export const Crumbs = styled(Breadcrumbs)`
  ${sharedLayout}
  list-style: none;
  gap: var(--spacing-xsmall);
`;

export const Crumb = styled(Breadcrumb)`
  ${sharedLayout}
  ${sharedFontStyles}
  gap: var(--spacing-xsmall);
  font-weight: var(--font-weight-regular);
  color: var(--black);

  & a {
    ${sharedFontStyles}
    font-weight: var(--font-weight-regular);
    text-decoration: none;
  }

  & svg {
    width: 16px;
    height: 16px;
  }
`;

export const CrumbLink = styled(Link)`
  ${sharedLayout}
  font-weight: var(--font-weight-regular);
  text-decoration: none;
`;

export const Separator = styled.span`
  ${sharedFontStyles}
`;
